<template>
  <section v-editable="blok" class="promo-general">
    <BaseNuxtImage
      v-if="blok.image"
      class="promo-general__image"
      :src="blok.image.filename"
      :alt="blok.image.alt"
    />
    <div class="promo-general__content">
      <StoryblokComponent
        v-for="childBlok in blok.content"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SbBlogPromoGeneral } from '@/types'

interface Props {
  blok: SbBlogPromoGeneral
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.promo-general {
  padding: 48px;
  border-radius: 16px;
  border: 1px solid var(--gray-300);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;

  @media (min-width: $breakpoint-md) {
    flex-direction: row;
  }

  &__image {
    margin-top: 12px;
    height: auto;
    width: 100%;
    max-width: 200px;
  }
}
</style>
